export default  `1. Aceitação dos Termos
Ao adquirir bilhetes para os eventos organizados por [Nome da Organização], você concorda com os presentes Termos e Condições. Caso não concorde com algum item, pedimos que não prossiga com a compra.

2. Compra e Uso dos Bilhetes
2.1. Os bilhetes são pessoais e intransferíveis, salvo autorização expressa da organização.
2.2. É de responsabilidade do comprador garantir que as informações fornecidas durante a compra estejam corretas.
2.3. A apresentação do bilhete é obrigatória para entrada no evento, podendo ser exigida em formato digital ou impresso.
2.4. Em caso de perda, roubo ou danificação do bilhete, a organização não se responsabiliza por sua reposição.

3. Cancelamento e Reembolso
3.1. Não serão realizados reembolsos em caso de desistência do comprador, salvo se previsto de outra forma pela legislação local.
3.2. Caso o evento seja cancelado, o comprador será notificado e o reembolso será realizado conforme as instruções fornecidas pela organização.
3.3. Em caso de adiamento, o bilhete continuará válido para a nova data. Não havendo possibilidade de comparecimento na nova data, o comprador pode solicitar o reembolso dentro do prazo estabelecido pela organização.

4. Conduta e Segurança no Evento
4.1. Todos os participantes devem respeitar as normas de segurança e conduta estabelecidas pela organização.
4.2. O acesso ao evento pode ser negado a qualquer pessoa que apresente comportamentos inadequados, esteja sob o efeito de substâncias ilegais ou que represente risco à segurança dos demais participantes.
4.3. Menores de idade só poderão participar mediante autorização expressa dos pais ou responsáveis e se permitido para o evento em questão.

5. Direitos de Imagem e Captação
5.1. Durante os eventos, poderão ser realizadas filmagens e fotografias para fins de divulgação. Ao participar, você autoriza o uso de sua imagem sem qualquer ônus ou notificação.
5.2. Caso não deseje que sua imagem seja utilizada, informe a organização previamente ao evento.

6. Limitação de Responsabilidade
6.1. A organização não se responsabiliza por objetos pessoais perdidos, roubados ou danificados durante o evento.
6.2. A participação no evento é de responsabilidade do comprador, sendo este responsável por quaisquer danos ou prejuízos que possa causar a terceiros ou à organização.

7. Alterações nos Termos e no Evento
7.1. A organização reserva-se o direito de alterar os presentes Termos e Condições a qualquer momento, mediante publicação no site oficial.
7.2. A programação, local e horário do evento estão sujeitos a alterações por motivos de força maior ou questões logísticas.

8. Contato
Para quaisquer dúvidas ou solicitações, entre em contato com a nossa equipe através do e-mail [email da organização] ou pelo telefone [número de contato].

9. Disposições Gerais
9.1. Estes Termos e Condições são regidos pelas leis aplicáveis em [país ou estado].
9.2. Qualquer disputa será resolvida no foro competente de [localidade].`
